/* Genera un combo de fechas ubicando la fecha enviada: Se recibe un objeto con fecha */

//*react- recursos

//*componentes-utiles
import GeneraComboFecha from "../../../componentes/generaComboFecha/GeneraComboFecha";

//*datos

//*clases
import "../componentes.css";
//import "../../../componentes/generaComboFecha/calendar.css";

//*vista
export default function Ejemplo() {
  //sacar fecha del sistema
  let fecha = "05/25/2022";
  let fechaNombre = "Fecha nombre 1";
  let fecha2 = Date(); //sacar la fecha de s.o.
  let fechaNombre2 = "Fecha nombre 2";
  let texto = "Texto adicional para fecha";
  let separar = true; //true lo deja el texto en una linea y el input en otra
  //false los deja en la misma linea
  //probar con fecha específica
  return (
    <div className="container container-Vista">  {/* className="container yellow" */}
      <h2>Ejemplo de generación un calendario fecha fija: <span className="color-blue">{fecha}</span></h2>
      <label>
          Llamada al componente:  <span className="color-blue">GeneraComboFecha</span> con los parámetros: fecha:  <span className="color-blue">{fecha}</span>,  fechaNombre:  <span className="color-blue">{fechaNombre}</span>, separar:  <span className="color-blue">true</span> (ubica el texto arriba del combo), texto <span className="color-blue"> '' </span> (no ocupo title en FechaNombre), 
      </label>
      <br/><br/>
      <div className="container-Componente" >
          <GeneraComboFecha
            texto={''}
            fecha={fecha}
            fechaNombre={fechaNombre}
            separar={true}
          />
      </div>
      
      <br/><br/>
      
      <h2>
        Ejemplo de generación un calendario fecha del sistema operativo:<span className="color-blue"> {fecha2}  </span>
      </h2>
      <label>
          Llamada al componente:  <span className="color-blue">GeneraComboFecha</span> con los parámetros: fecha:  <span className="color-blue">{fecha2}</span>,  fechaNombre:  <span className="color-blue">{fechaNombre2}</span>, separar:  <span className="color-blue">false</span> (ubica el texto a la izquierda del combo), texto <span className="color-blue">{texto}</span> (title para fechaNombre), 
      </label>
      <br/><br/>
      <div className="container-Componente" >
        <GeneraComboFecha
          texto={texto}
          fecha={fecha2}
          fechaNombre={fechaNombre2}
          separar={false}
        />
      </div>
    </div>
  );
}
